import React from "react";
import styled from "styled-components";

export const Wrap = styled.div`
  margin-top: 50px !important;
  .serviceEnquiry {
    p {
      font-size: 16px;
      text-align: center;
      span {
        color: #2a3795;
        font-weight: bold;
        display: block;
      }
    }
    a.btn-serviceEnquiry {
      width: 354px;
      display: block;
      margin: 0 auto;
      margin-bottom: 8px;
      background: #2a3795;
      color: #fff;
      padding: 15px 0 15px 0;
      text-decoration: none;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      border-radius: 3px;
    }

    a.btn-onlineQuotation {
      width: 354px;
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
      background: #47b549;
      color: #fff;
      padding: 15px 0 15px 0;
      text-decoration: none;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      border-radius: 3px;
    }

    .phoneNumBlk {
      font-size: 16px;
      text-align: center !important;
      color: #636363;

      .phoneNum {
        a {
          color: #2a3795;
          text-decoration: none;
          font-weight: bold;
        }
      }
    }
  }
`;

function ServiceEnquiry(props) {
  const { lng } = props;
  return (
    <Wrap>
      <div className="serviceEnquiry">
        <a
          className="btn-onlineQuotation"
          to={`/${lng}/pricing#step1`}
          data-cta="Quotation-Online"
        >
          All Cloud Service
        </a>
        <a
          className="btn-serviceEnquiry"
          to={`/${lng}/enquiry`}
          data-cta="Service-Enquiry"
        >
          Service Enquiry
        </a>
        <p className="phoneNumBlk">
          For more details, feel free to call
          <br />
          <span className="phoneNum">
            <a href="tel:+85225547545" data-cta="CS-Call-Service">
              (852) 2554 7545
            </a>
          </span>
        </p>
      </div>
    </Wrap>
  );
}

export default ServiceEnquiry;
